var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 193.4 300",
    viewBox: "0 0 193.4 300",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -290.65)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m22.7 290.7c-11.8-0.3-21.5 9.1-21.8 20.9-0.1 6.5 2.7 12.8 7.8 16.9l130.5 111.8-130.5 111.8c-9.5 7-11.5 20.3-4.6 29.8 7 9.5 20.3 11.5 29.8 4.6 0.9-0.6 1.7-1.3 2.4-2.1l149.5-127.9c9-7.7 10-21.1 2.4-30.1-0.7-0.9-1.5-1.7-2.4-2.4l-149.4-128c-3.8-3.3-8.6-5.2-13.7-5.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.77c495858abf15d09488f06f454a34ad.svg";
export { ForwardRef as ReactComponent };